import { OrderState } from '@/types';

export const orderListTabConfigs = [
  { text: '全部', icon: ``, id: '' },
  { text: '待付款', icon: ``, id: OrderState.ArrangingPayment },
  { text: '待发货', icon: ``, id: OrderState.PaymentSettled },
  { text: '待收货', icon: ``, id: OrderState.Shipped },
  { text: '已完成', icon: ``, id: OrderState.ConfirmReceiptOfGoods },
];

export const userOrderTabConfigs = [
  // toBeAfterSalesNumber: 售后
  // toBeEvaluatedNumber: 待评价
  // toBePaidNumber: 待支付
  // toBeReceivedNumber: 待收货
  // toBeShippedNumber: 待发货
  {
    text: '待付款',
    icon: `https://cdn.s3.mall.startcatcher.com/public/wait_pay.png`,
    id: OrderState.ArrangingPayment,
    numKey: 'toBePaidNumber',
    num: 0,
  },
  {
    text: '待发货',
    icon: `https://cdn.s3.mall.startcatcher.com/public/wait_ship.png`,
    id: OrderState.PaymentSettled,
    numKey: 'toBeShippedNumber',
    num: 0,
  },
  {
    text: '待收货',
    icon: `https://cdn.s3.mall.startcatcher.com/public/wait_receipt.png`,
    id: OrderState.Shipped,
    numKey: 'toBeReceivedNumber',
    num: 0,
  },
  {
    text: '待评价',
    icon: `https://cdn.s3.mall.startcatcher.com/public/wait_comment.png`,
    id: 'evaluate',
    numKey: 'toBeEvaluatedNumber',
    num: 0,
  },
  {
    text: '退款/售后',
    icon: `https://cdn.s3.mall.startcatcher.com/public/refund.png`,
    id: 'refund',
    numKey: 'toBeAfterSalesNumber',
    num: 0,
  },
];
